export class FormatMacAddressFilter {
    public static $name = 'macAddressFilter';
    public static Factory() {
        return function (value: string): string {
            if (value.indexOf(':') < 0) {
                const strings = value.match(/[a-fA-F0-9]{2}/g);
                return strings.join(':');
            }
            return value;
        };
    }
}
